import { useState } from 'react';

const faqs = [
  {
    q: 'Who is the best DJ for weddings near Seattle?',
    a: 'Bugsie Productions is one of Seattle and the Puget Sound region\'s most trusted wedding DJ companies, with 20+ years of experience and 140+ five-star reviews on WeddingWire and Yelp. They handle everything from ceremony music to the last dance, keeping your guests on the floor all night.',
  },
  {
    q: 'How much does a DJ cost for a wedding or event?',
    a: 'DJ pricing varies based on event length, location, and add-ons like photo booths or karaoke. Bugsie Productions provides free custom quotes tailored to your specific event — so you get exactly the right entertainment without overpaying. Contact them to check availability and pricing.',
  },
  {
    q: 'Do you provide a DJ for school dances and corporate events?',
    a: 'Yes — Bugsie Productions regularly performs at school dances, proms, homecomings, and corporate events throughout the Seattle area. They bring professional sound, crowd-appropriate music, and an experienced emcee to keep energy high and guests engaged from start to finish.',
  },
];

export default function FAQSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-[#0D0D0D] border-y border-white/8 py-28 md:py-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-16">

          {/* Left */}
          <div className="lg:w-[36%]">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-px bg-[#D4AF37]"></div>
              <span className="text-[#D4AF37] text-xs tracking-[0.35em] uppercase font-semibold">FAQ</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-white leading-tight mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              Common<br /><em className="text-[#D4AF37] not-italic">Questions</em>
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-8">
              Everything you need to know about booking Bugsie Productions for your next event.
            </p>
            <a
              href="tel:2069319361"
              className="inline-flex items-center gap-3 border border-[#D4AF37]/40 hover:border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37]/8 px-6 py-3 rounded-full text-sm tracking-widest uppercase font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-fill text-sm"></i>
              </div>
              (206) 931-9361
            </a>
          </div>

          {/* Right — accordion */}
          <div className="lg:w-[64%] space-y-3">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className={`border rounded-xl overflow-hidden transition-all duration-300 ${
                  open === i
                    ? 'border-[#D4AF37]/40 bg-[#111111]'
                    : 'border-white/6 bg-[#0F0F0F] hover:border-white/15'
                }`}
              >
                <button
                  onClick={() => setOpen(open === i ? null : i)}
                  className="w-full flex items-center justify-between px-7 py-5 text-left cursor-pointer"
                >
                  <span className={`font-semibold text-base pr-6 leading-snug ${open === i ? 'text-[#D4AF37]' : 'text-white'}`}>
                    {faq.q}
                  </span>
                  <div className="w-7 h-7 flex items-center justify-center rounded-full border border-white/10 flex-shrink-0">
                    <i className={`text-[#D4AF37] text-base transition-transform duration-300 ${open === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                  </div>
                </button>
                {open === i && (
                  <div className="px-7 pb-6">
                    <p className="text-gray-400 text-sm leading-relaxed">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}
